import { useNavigate } from 'react-router';
import { getDashboardRedirectPath } from '@/bundle/Auth/LoginFlow/LoginPage/const/const';
import { LogoWrapper, MenuHeader, OrganizationDetailsWrapper, OrganizationIcon, OrganizationName } from './styles';
import { useUser } from '@/context/userContext';
import { getOrganizationName } from '@/helpers/userHelpers';

export const SidebarHeader = () => {
  const navigate = useNavigate();
  const { user, currentRole, isAdminRole } = useUser();
  const organizationName = getOrganizationName(user);
  const showOrganizationName = isAdminRole && !!organizationName;

  const redirectToDashboard = () => {
    const dashboardPath = getDashboardRedirectPath(currentRole);

    navigate(dashboardPath);
  };

  return (
    <>
      <MenuHeader>
        <LogoWrapper onClick={redirectToDashboard} />
      </MenuHeader>
      {showOrganizationName && (
        <OrganizationDetailsWrapper>
          <OrganizationIcon />
          <OrganizationName>{organizationName}</OrganizationName>
        </OrganizationDetailsWrapper>
      )}
    </>
  );
};
